/* Qué se puede comprar cada día: lo que dice «Dónde buscar» se cruza con los sitios por los que se pasa
   (24a). Lo que vale en cualquier Donki o súper no se repite cada día: va aparte, en la Guía. */
import type { Compra, Dia } from './tipos.ts';

// [lo que pone en «Dónde buscar», lo que tiene que aparecer en el día]
const SITIOS: [RegExp, RegExp][] = [
  [/kyoto|kioto/i, /kioto|kyoto/i],
  [/tokyo|tokio/i, /tokio|tokyo/i],
  [/osaka/i, /osaka/i],
  [/akihabara|akiba/i, /akihabara/i],
  [/den den|nipponbashi/i, /den den/i],
  [/ikebukuro/i, /ikebukuro/i],
  [/kappabashi/i, /kappabashi/i],
  [/asakusa/i, /asakusa/i],
  [/shibuya|village vanguard/i, /shibuya/i],
  [/nakano|mandarake/i, /nakano/i],
  [/usj|super nintendo|nintendo osaka/i, /usj|nintendo/i],
  [/nintendo tokyo/i, /shibuya/i],
  [/d'z|shibusan|ikaho|haruna|initial d|autobacs/i, /haruna|ikaho|jdm/i],
  [/surugaya|bookoff|super potato|card labo|hareruya|tcg|modelismo|tiendas frikis/i, /akihabara|den den|nakano|ikebukuro/i],
  [/pok[eé]mon center/i, /pok[eé]mon center|ikebukuro|nihonbashi|tokyo station/i],
  [/templo|santuario/i, /templo|santuario|kiyomizu|kinkaku|fushimi|tōdai|todai|meiji|kasuga|zōjō/i],
];
const EN_CUALQUIER_SITIO = /don quijote|donki|supermercad|konbini|loft|hands|daiso|souvenirs|recuerdos|durante el viaje|estaciones/i;

const textoDia = (d: Dia) => [d.zona, d.titulo, d.ruta.join(' '), d.bloques.map(b => b.que).join(' '), d.eje ?? ''].join(' ');

export const esCabecera = (c: Compra) => c.tipoFila === 'PRESUPUESTO';

/** Las compras que encajan con los sitios de ese día. */
export function comprasDelDia(compras: Compra[], d: Dia): Compra[] {
  const dia = textoDia(d);
  return compras.filter(c => c.donde && SITIOS.some(([donde, aqui]) => donde.test(c.donde!) && aqui.test(dia)));
}

/** Las que se pueden comprar en cualquier parte (Donki, súper…) y no están atadas a un sitio. */
export const comprasEnCualquierSitio = (compras: Compra[]) =>
  compras.filter(c => c.donde && EN_CUALQUIER_SITIO.test(c.donde) && !SITIOS.some(([donde]) => donde.test(c.donde!)));

/** Texto de la casilla de una compra. */
export function tituloCompra(c: Compra): string {
  if (c.lista === 'regalos') return c.para ? `${c.para}: ${c.que}` : c.que;
  if (c.lista === 'comunes') return c.grupo ? `${c.grupo}: ${c.que}` : c.que;
  return c.que;
}
